/**
 * Error codes returned for authentication requests
 */
export enum AuthErrorCode {
  InvalidLogin = 'INVALID_LOGIN',
  UserSuspended = 'USER_SUSPENDED',
}
